import React from 'react';
import { FieldGroup } from '@ver-uds/react';
import { Account, AccountType, MouTemplateType } from 'eve-account-client';
import { generatePath, Link } from 'react-router-dom';
import { EveRoutes } from '@ver-uds/e-verify';
import { AuthFileLinkProps } from '../../AuthFileLink';

export type MouLinkType = MouTemplateType | string;

export interface CompanyAccessMOUProps {
  accountData?: Pick<Account, 'type' | 'id' | 'mouSignedDate'>;
  linkToMou: React.ReactElement<AuthFileLinkProps<MouLinkType>>;
}

const CompanyAccessMOU = ({ accountData, linkToMou }: CompanyAccessMOUProps): JSX.Element => {
  const children = [React.cloneElement(linkToMou, { key: 'mou-link' })];
  const showUploadSignaturePage =
    accountData?.id && !accountData.mouSignedDate && accountData?.type === AccountType.CLIENT;
  if (showUploadSignaturePage) {
    children.push(
      <Link
        key="upload-link"
        to={generatePath(EveRoutes.COMPANY_CLIENTS_CLIENT_MOU_UPLOAD, { subAccountId: accountData?.id })}
        className="usa-button usa-button--outline margin-top-3"
      >
        Upload Signature Page
      </Link>,
    );
  }

  return (
    <FieldGroup.Field className="tablet:grid-col-6" name="Memorandum of Understanding">
      {children.map((el) => el)}
    </FieldGroup.Field>
  );
};

export default CompanyAccessMOU;
